import React, { useState } from "react";
import { Space, Button } from "@masterteam/mt-design-react";
import { FormattedMessage } from "react-intl";

import { WizardStep } from "../Wizard";
import History from "../../AddNewInitiative/History";
import Steps from "../../Steps";
import Modal from "../../Modal";
import RequestActionModal from "../../RequestActionModal";

import { REQUEST_STATUSES } from "../../../configs/enums";

const initialActionModal = {
  isOpen: false,
  isApprove: false,
  isReturn: false,
  data: null,
};

function HistoryStep({
  formBag,
  historyLog = [],
  approvalSteps = [],
  refetchData,
}) {
  const [actionModal, setActionModal] = useState(initialActionModal);

  const { values } = formBag;

  const currentStep = approvalSteps?.find(
    (e) => e?.Status === REQUEST_STATUSES.PENDING
  );

  return (
    <WizardStep name="History">
      <Space className="kpi-wizard__history-step" direction="vertical">
        <Space
          direction="vertical"
          className="kpi-wizard__history-step__header"
        >
          <Space
            align="center"
            className="kpi-wizard__history-step__header__actions"
          >
            {currentStep?.CanApprove ? (
              <>
                <Button
                  variant="success"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionModal({
                      isOpen: true,
                      isApprove: true,
                      data: values,
                    });
                  }}
                >
                  <FormattedMessage id="common.approve" />
                </Button>
                <Button
                  variant="dark"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionModal({
                      isOpen: true,
                      isApprove: false,
                      isReturn: true,
                      data: values,
                    });
                  }}
                >
                  <FormattedMessage id="common.return" />
                </Button>
                <Button
                  variant="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    setActionModal({
                      isOpen: true,
                      isApprove: false,
                      data: values,
                    });
                  }}
                >
                  <FormattedMessage id="common.reject" />
                </Button>
              </>
            ) : null}
          </Space>
          <Space>
            <Steps steps={approvalSteps} />
          </Space>
        </Space>
        <Space className="kpi-wizard__history-step__content">
          <History data={historyLog} />
        </Space>
      </Space>
      {actionModal.isOpen ? (
        <Modal isOpen={actionModal.isOpen}>
          <RequestActionModal
            measureItem={actionModal?.data}
            callback={refetchData}
            closeModal={() => setActionModal(initialActionModal)}
            isApprove={actionModal?.isApprove}
            isReturn={actionModal?.isReturn}
          />
        </Modal>
      ) : null}
    </WizardStep>
  );
}

export default HistoryStep;
